document.addEventListener('DOMContentLoaded', function () {
  /**
   * Generates a Table of Contents by creating anchor links for each <h2> element
   * and appending them to the designated Table of Contents container.
   *
   * @param {HTMLElement} [tocContainer] - The container element to append the Table of Contents to.
   * @param {HTMLElement} [sourceElement] - The element containing the <h2> elements to generate the Table of Contents from.
   */
  function generateTableOfContents(
    tocContainer = null,
    sourceElement = null
  ) {
    const tocContainers = tocContainer
      ? [tocContainer]
      : document.querySelectorAll('[data-js-toc]');
    if (!tocContainers.length) return;

    sourceElement =
      sourceElement ||
      document.querySelector('[data-js-toc-source]') ||
      tocContainers[0].parentNode;
    const headings = sourceElement.querySelectorAll('h2');
    if (!headings.length) return;

    const headingIdPrefix = 'toc-heading-';

    tocContainers.forEach((toc) => {
      const fragment = document.createDocumentFragment();

      headings.forEach((heading, index) => {
        const headingId = `${headingIdPrefix}${index + 1}`;
        const anchor = document.createElement('a');
        anchor.href = `#${headingId}`;

        // Remove numbering from the beginning of the heading
        const headingText = heading.textContent.replace(/^\d+[\.\)]\s*/, '');
        anchor.textContent = headingText;
        anchor.className = 'table-of-contents-link';

        heading.id = headingId;

        const listItem = document.createElement('li');
        listItem.className = 'table-of-contents-list-item';
        listItem.appendChild(anchor);
        fragment.appendChild(listItem);
      });

      toc.innerHTML = ''; // Clear existing content
      toc.appendChild(fragment);
    });

    // Blog - Expand TOC on click
    const expandButton = document.querySelector('[js-toc-cta-expand]');
    if (expandButton) {
      expandButton.addEventListener('click', function () {
        this.classList.add('hidden');
        const tocContainer = document.querySelector('[data-toc-collapsible]');
        if (tocContainer) {
          tocContainer.classList.remove('toc-collapsed');
        }
      });
    }
  }

  // Generate the Table of Contents
  generateTableOfContents();
});
